import {Component, OnInit, TemplateRef} from '@angular/core';
import {
    FormBuilder,
    Validators,
    FormsModule,
    ReactiveFormsModule,
    FormGroup,
    FormControl,
    FormArray,

    ValidatorFn,
    AbstractControl, ValidationErrors,
} from '@angular/forms';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { MatButtonModule } from '@angular/material/button';
import {CommonModule, DecimalPipe, NgForOf, NgIf, NgStyle} from '@angular/common';
import { MatAutocompleteSelectedEvent, MatAutocompleteTrigger, MatAutocomplete, MatOption } from '@angular/material/autocomplete';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatSliderChange, MatSliderModule } from '@angular/material/slider';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/divider';
import { Observable, Subscription, startWith, map } from 'rxjs';
import { ConfiguratorStateService } from '../../../Services/ListConfiguration/configurator-state.service';
import { ListpreviewComponent } from '../listpreview/listpreview.component';
import {
    AVAILABLE_INDUSTRIES_DATASTRUCT, ColumnExplanation,
    getColumnExplanation,
    IndustryOverviewEntry
} from '../InfoConverstion';
// Import the new services and interfaces
import { ListConfiguratorService, StateRow, CompanyInfoRow } from '../../../Services/ListConfiguration/ListConfiguratorService'; // Adjust path as needed
import { ListConfiguratorFormService, atLeastOneSelectedValidator } from '../../../Services/ListConfiguration/ListConfiguratorFormService';
import {Router} from '@angular/router';
import {ColorScssService} from '../../../shared/service/color-scss.service';
import {MatDialog} from '@angular/material/dialog';
import {ColumnExplanationModalComponent} from './column-explanation-modal/column-explanation-modal.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';


export interface Industry {
    name: string;
}

@Component({
    selector: 'app-listconfigurator',
    standalone: true,
    imports: [
        MatButtonModule,
        MatStepperModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        NgStyle,
        MatAutocompleteTrigger,
        MatAutocomplete,
        MatOption,
        NgForOf,
        MatCheckbox,
        MatSliderModule,
        CommonModule,
        MatIcon,
        ListpreviewComponent,
        MatDivider,
        DecimalPipe,
    ],
    templateUrl: './listconfigurator.component.html',
    styleUrl: './listconfigurator.component.scss'
})
export class ListconfiguratorComponent implements OnInit {
    selectedColumnExplanation: ColumnExplanation | null = null;
    filteredIndustries!: Observable<Industry[]>;
    private subscriptions = new Subscription();

    quantity: number = 1000;
    readonly sliderStep: number = 500;
    readonly sliderMin: number = 1000;
    protected readonly Math = Math;

    isLinear = false;
    branchFormGroup!: FormGroup;
    regionFormGroup!: FormGroup;
    companyInfosGroup!: FormGroup;
    quantityFormGroup!: FormGroup;

    // Expose data from ListConfiguratorService
    states: StateRow[] = [];
    companyInfos: CompanyInfoRow[] = [];
    basicInfos: CompanyInfoRow[] = [];
    contactInfos: CompanyInfoRow[] = [];
    additionalInfos: CompanyInfoRow[] = [];

    constructor(
        public stateConfig: ConfiguratorStateService,
        private listConfiguratorService: ListConfiguratorService,
        private listConfiguratorFormService: ListConfiguratorFormService,
        private router: Router,
        private modalService: NgbModal,
        private color: ColorScssService
    ) {
        color.resetColorScheme()
        // Initialize forms using the FormService
        const { branchFormGroup, regionFormGroup, companyInfosGroup, quantityFormGroup } =
            this.listConfiguratorFormService.createConfiguratorForms(
                this.listConfiguratorService.states.map(() => true),
                this.listConfiguratorService.companyInfos,
                this.quantity
            );

        this.branchFormGroup = branchFormGroup;
        this.regionFormGroup = regionFormGroup;
        this.companyInfosGroup = companyInfosGroup;
        this.quantityFormGroup = quantityFormGroup;

        // Set initial values for states and companyInfos from the service
        this.states = [...this.listConfiguratorService.states];
        this.companyInfos = [...this.listConfiguratorService.companyInfos];
    }

    ngOnInit(): void {
        const branchControl = this.branchFormGroup.get(
            'branchCtrl'
        ) as FormControl<IndustryOverviewEntry | null>; // Adjust the type if needed

        this.filteredIndustries = branchControl.valueChanges.pipe(
            startWith<IndustryOverviewEntry | string | null>(''),
            map(value => {
                const search = typeof value === 'string' ? value : value?.name || '';

                return search
                    ? this.listConfiguratorFormService.filterIndustries(search)
                    : AVAILABLE_INDUSTRIES_DATASTRUCT.slice();
            })
        );

        // Initial filtering of companyInfos
        this.updateCategorizedCompanyInfos();

        // Subscribe to changes in FormArrays
        this.statesArray.controls.forEach((ctrl, idx) => {
            this.subscriptions.add(
                ctrl.valueChanges.subscribe(() => {
                    this.updateSelectedStates(idx);
                })
            );
        });

        this.companyInfosArray.controls.forEach((ctrl, idx) => {
            this.subscriptions.add(
                ctrl.valueChanges.subscribe(() => {
                    this.updateSelectedCompanyInfos();
                })
            );
        });

    }

    openHelpModal(content: TemplateRef<any>, label: string): void {
        this.selectedColumnExplanation = getColumnExplanation(label);
        this.modalService.open(content, { centered: true });
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    // ---------------------- Getters for FormArrays --------------------------------

    get statesArray(): FormArray {
        return this.regionFormGroup.get('states') as FormArray;
    }

    get companyInfosArray(): FormArray {
        return this.companyInfosGroup.get('companyInfos') as FormArray;
    }

    // ---------------------- Navigation --------------------------------

    goToNextStep(stepper: MatStepper) {
        const currentStep = stepper.selectedIndex;

        if (currentStep === 1) {
            if (this.regionFormGroup.invalid) {
                this.regionFormGroup.get('states')?.markAsTouched();
                this.regionFormGroup.get('states')?.markAsDirty();
                return;
            } else if (this.stateConfig.selectedQuantity < this.stateConfig.minimumSelectedQuantity) {
                this.regionFormGroup.get('minimum')?.markAsTouched();
                this.regionFormGroup.get('minimum')?.markAsDirty();
                return;
            }
            console.log(this.stateConfig.selectedQuantity);
        }

        if (currentStep === 2) {
            if (this.companyInfosGroup.invalid) {
                this.companyInfosGroup.get('companyInfos')?.markAsTouched();
                this.companyInfosGroup.get('companyInfos')?.markAsDirty();
                return;
            } else if (this.stateConfig.selectedQuantity < this.stateConfig.minimumSelectedQuantity) {
                this.companyInfosGroup.get('minimum')?.markAsTouched();
                this.companyInfosGroup.get('minimum')?.markAsDirty();
                return;
            }

            console.log(this.stateConfig.selectedQuantity);

        }
        stepper.next();
    }

    onIndexChange(index: number) {
        if (index == 1) {
            this.listConfiguratorService.loadStateCounts(this.stateConfig.selectedTable);
            this.states = [...this.listConfiguratorService.states];
        }

        if (index == 2) {
            this.listConfiguratorService.getPropertyCount(this.stateConfig.selectedTable, this.stateConfig.selectedStates);
            // Re-filter and update companyInfos after counts are loaded
            this.subscriptions.add(
                this.stateConfig.selectedStates$.subscribe(() => {
                    this.companyInfos = [...this.listConfiguratorService.companyInfos];
                    this.updateCategorizedCompanyInfos();
                })
            );
        }
    }

    // ---------------------- Branch --------------------------------

    onBranchSelected(event: MatAutocompleteSelectedEvent) {
        const branch = event.option.value;
        this.stateConfig.fetchTableUpdateRowInfos(branch.slug);
        this.quantityControl.setValue(this.forgedSliderMax);
    }

    displayFn(branch?: Industry): string {
        return branch ? branch.name : '';
    }

    // ---------------------- REGION --------------------------------

    toggleStateArray(array: FormArray, i: number): void {
        const ctrl = array.at(i);
        ctrl.setValue(!ctrl.value);
    }

    private updateSelectedStates(changedIdx?: number): void {
        if (changedIdx !== undefined) {
            console.log('Checkbox index changed:', changedIdx);
        }

        // If the first checkbox (“Alle”) is ticked, tick every other one too
        if (this.statesArray.at(0).value && changedIdx === 0) {
            this.statesArray.controls.forEach((ctrl, idx) => {
                if (idx !== 0 && !ctrl.value) {
                    ctrl.setValue(true, { emitEvent: false });
                }
            });
        } else if (this.statesArray.at(0).value && changedIdx !== 0) {
            this.statesArray.controls.forEach((ctrl, idx) => {
                if (idx === 0 ) {
                    ctrl.setValue(false, { emitEvent: false });
                }
            });
        } else if (!this.statesArray.at(0).value && changedIdx === 0)  {
            // Set all others false if "Alle" is unticked
            this.statesArray.controls.forEach((ctrl, idx) => {
                if (idx !== 0 && ctrl.value) {
                    ctrl.setValue(false, { emitEvent: false });
                }
            });
        }

        const selected: string[] = this.states
            .filter((_, idx) => this.statesArray.at(idx).value)
            .map(stateRow => stateRow.label);

        let finalSelected: string[];
        if (selected.includes('Deutschlandweit')) {
            finalSelected = ['Deutschlandweit'];
        } else {
            finalSelected = selected.filter(state => state !== 'Deutschlandweit');
        }

        this.stateConfig.setStates(finalSelected);
        this.quantityControl.setValue(this.forgedSliderMax);
    }

    // ---------------------- Companies --------------------------------

    toggleCompanyInfo(array: FormArray, i: number): void {
        const ctrl = array.at(i);
        ctrl.setValue(!ctrl.value);
    }

    private updateSelectedCompanyInfos() {
        const selected: string[] = this.companyInfos
            .filter((_, idx) => this.companyInfosArray.at(idx).value)
            .map(infoRow => infoRow.label);
        this.stateConfig.fetchUpdatedCompanyInfos(selected);
        this.quantityControl.setValue(this.forgedSliderMax);
    }

    private updateCategorizedCompanyInfos(): void {
        this.basicInfos = this.companyInfos.filter(i => i.category === 'basic');
        this.contactInfos = this.companyInfos.filter(i => i.category === 'contact');
        this.additionalInfos = this.companyInfos.filter(i => i.category === 'additional');
    }

    // ---------------------- Quantity --------------------------------
    get quantityControl() {
        return this.quantityFormGroup.get('quantity') as FormControl;
    }

    onQuantityChange() {
        // always reads the up-to-date form value
        const sliderValue = this.quantityControl.value as number;
        const realValue   = this.calcSliderDisplayValue(sliderValue);
        console.log('Slider value changed to:', realValue);
        this.stateConfig.updateQuantityPrice(realValue);

        console.log(this.forgedSliderMax);
    }

    get forgedSliderMax(): number {
        const baseMax = this.stateConfig.availableRowCount;
        return Math.max(this.sliderMin, Math.ceil(baseMax / this.sliderStep) * this.sliderStep);
    }

    calcSliderDisplayValue(value: number): number {
        const maxQty = this.stateConfig.availableRowCount;
        let displayValue = value;

        if ((value >= this.forgedSliderMax && this.forgedSliderMax >= maxQty) || (value > maxQty && maxQty > 0)) {
            displayValue = maxQty;
        }
        displayValue = Math.max(this.sliderMin, displayValue);
        return Math.round(displayValue);
    }

    sliderDisplayWith = (value: number): string => {
        return String(this.calcSliderDisplayValue(value));
    };

    navigateToOrderPage() {
        this.router.navigate(['/checkout']);
    }
}